import { useState } from 'react'
import { useIntl } from '@/intl'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    showDetail: translate({ id: 'rm.contextual.order.showDetail' }),
  }))

  return api
}
